import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import HomeScreen from "../pages/unauth/home/HomeScreen";
import NoPage from "../pages/noPage/NoPage";
import AdminLogin from "../pages/unauth/adminLogin/AdminLogin";
import Footer from "../components/ui/footer/Footer";
import Doctor from "../pages/unauth/Doctor/Doctor";
import Treatment from "../pages/unauth/treatment/Treatment";
import Insurance from "../pages/unauth/insurance/Insurance";
import { motion } from "framer-motion";
import PrimaryLayout from "./PrimaryLayout";
import SecondaryLayout from "./SecondaryLayout";
import Pedodontists from "../pages/unauth/treatment/Pedodontists";
import Orthodontists from "../pages/unauth/treatment/Orthodontists";
import Periodontists from "../pages/unauth/treatment/Periodontists";
import Endodontists from "../pages/unauth/treatment/Endodontists";

export default function UnAuthLayout() {
  const id = "insurance";
  const [isOpen, setOpen] = useState(false);
  const handleScrollToTop = () => {
    const duration = 0.5; // Duration of the scroll animation
    const start = window.pageYOffset;
    const startTime = performance.now();

    const scroll = (currentTime) => {
      const timeElapsed = (currentTime - startTime) / 1000;
      const progress = Math.min(timeElapsed / duration, 1);
      window.scrollTo({
        top: start * (1 - progress),
        behavior: "smooth",
      });
      if (progress < 1) {
        requestAnimationFrame(scroll);
      }
    };

    requestAnimationFrame(scroll);
  };

  const [isHeaderFixed, setIsHeaderFixed] = useState(true);
  const [prevScrollPos, setPrevScrollPos] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      setIsHeaderFixed(
        currentScrollPos < prevScrollPos && currentScrollPos > 0
      );
      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollPos]);

  return (
    <div className={`${isOpen ? "relative" : "relative"}`}>
      <motion.button
        onClick={handleScrollToTop}
        className="bg-[#3AA297] rounded-full fixed text-black-2 z-99 bottom-10 xl:right-10 lg:right-7 md:right-6 right-2"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        whileHover={{
          scale: 1.5,
          transition: { yoyo: Infinity },
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          shape-rendering="geometricPrecision"
          text-rendering="geometricPrecision"
          image-rendering="optimizeQuality"
          fill-rule="evenodd"
          clip-rule="evenodd"
          className="w-[40px] h-[40px]"
          viewBox="0 0 511.998 511.998"
        >
          <path
            fill="white"
            fill-rule="nonzero"
            d="M255.999 511.999c70.684-.001 134.695-28.658 181.019-74.981 46.323-46.324 74.981-110.335 74.98-181.019 0-70.691-28.657-134.695-74.98-181.018C390.694 28.657 326.691 0 255.999 0 185.308 0 121.304 28.657 74.981 74.981 28.657 121.304 0 185.308 0 255.999c0 70.684 28.657 134.695 74.981 181.019 46.323 46.323 110.327 74.981 181.018 74.981zm-74.995-203.995c-29.412 16.955-43.962-6.609-27.542-23.789l84.234-95.914c15.311-15.318 21.289-15.318 36.607 0l84.234 95.914c16.303 17.26 2.086 40.686-27.549 23.789l-74.989-44.549-74.995 44.549zM410.99 410.99c-39.657 39.657-94.473 64.199-154.991 64.199-60.525 0-115.334-24.542-154.991-64.199-39.657-39.657-64.199-94.473-64.199-154.991 0-60.525 24.542-115.334 64.199-154.991 39.657-39.657 94.466-64.199 154.991-64.199 60.526 0 115.334 24.542 154.991 64.199 39.657 39.657 64.199 94.466 64.199 154.991 0 60.518-24.542 115.334-64.199 154.991z"
          />
        </svg>
      </motion.button>
      <Routes>
        <Route path="/">
          <Route
            index
            element={
              <PrimaryLayout isOpen={isOpen} setOpen={setOpen}>
                <HomeScreen id="about" />
              </PrimaryLayout>
            }
          />
          <Route
            path="home"
            element={
              <PrimaryLayout isOpen={isOpen} setOpen={setOpen}>
                <HomeScreen />
              </PrimaryLayout>
            }
          />
          {/* <Route path="about" element={<AboutScreen />} /> */}
          <Route path="admin-login" element={<AdminLogin />} />
          <Route
            path="/:id"
            element={
              <SecondaryLayout isOpen={isOpen} setOpen={setOpen}>
                <Doctor />
              </SecondaryLayout>
            }
          />

          <Route
            path="treatment"
            element={
              <SecondaryLayout isOpen={isOpen} setOpen={setOpen}>
                <Treatment />
              </SecondaryLayout>
            }
          />
          <Route
            path="treatment/pedodontists"
            element={
              <SecondaryLayout isOpen={isOpen} setOpen={setOpen}>
                <Pedodontists />
              </SecondaryLayout>
            }
          />
          <Route
            path="treatment/orthodontists"
            element={
              <SecondaryLayout isOpen={isOpen} setOpen={setOpen}>
                <Orthodontists />
              </SecondaryLayout>
            }
          />
          <Route
            path="treatment/periodontists"
            element={
              <SecondaryLayout isOpen={isOpen} setOpen={setOpen}>
                <Periodontists />
              </SecondaryLayout>
            }
          />
          <Route
            path="treatment/endodontists"
            element={
              <SecondaryLayout isOpen={isOpen} setOpen={setOpen}>
                <Endodontists />
              </SecondaryLayout>
            }
          />

          <Route
            // id="insurance"
            path="/insurance"
            element={
              <SecondaryLayout id={id} isOpen={isOpen} setOpen={setOpen}>
                <Insurance />
              </SecondaryLayout>
            }
          />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
      <div className="footer" id="contact">
        <Footer />
      </div>
    </div>
  );
}
